

import React, { useState, useRef } from "react";
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import Header from '../../../../components/layout/headers/Header'
import AdsTable from './AdsTable'

const ManageAds = () => {
    

    return (
        <>
        <Header />
        <Sidebar />
        <div className="content-body">
            <div className="w-full px-4">
                <AdsTable />
            </div>
        </div> 
        </>
    );
};

export default ManageAds;
